// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1a8736e3","251":"345ff9d2","373":"9fbca7bc","434":"732a5a6c","457":"3f73e4e7","667":"7562d0e7","750":"34c53c96","789":"e56ed950","966":"5ff25baa","988":"e2cfce44"}[chunkId] + ".chunk.js";
};